import React from "react";

import getSchemaOrgJSONLD from "components/SEO/getSchemaOrgJSONLD";

import defaultCoverImage from "images/meta-images/polotheme-cover.png";

interface Author {
  name: string;
  organization: string;
}

interface PageMetaData {
  uid?: string;
  title?: string;
  datePosted?: string;
  date?: string;
  type?: string;
  author?: Author;
  validityInDays?: string;
  monthsOfExperience?: number;
  educationRequirements?: string[];
  salaryMin?: number;
  salaryMax?: number;
  remoteEligible?: boolean;
  description?: string;
  category?: string;
  skills?: string[];
  image?: {
    src: string;
  };
  tags?: string[];
  slug?: string;
  jobDescriptions?: string[];
  perks?: string[];
  positionOpen?: number;
  keywords?: string;
  featuredImage?: {
    src: string;
  };
  remoteOnly?: boolean;
  vacancyCount?: number;
  price?: string;
  sku?: string;
}

interface SiteMetadata {
  title?: string;
  siteUrl?: string;
  description?: string;
  keywords?: string;
}

interface SiteMetaDataProps {
  siteMetadata?: SiteMetadata;
  pageMetaData?: PageMetaData;
  path: string;
}

const SiteMetaData: React.FC<SiteMetaDataProps> = ({
  siteMetadata,
  pageMetaData,
  path,
}) => {
  const {
    title: siteTitle,
    description: siteDescription,
    keywords: siteKeywords,
  } = siteMetadata;

  const {
    title: pageTitle,
    description: pageDescription,
    metaDescription,
    keywords: pageKeywords,
    featuredImage: pageImage,
  } = pageMetaData;

  const title = pageTitle || siteTitle;
  const description = metaDescription || pageDescription || siteDescription;
  const keywords = pageKeywords || siteKeywords;
  const coverImage = pageImage || defaultCoverImage;
  const imageUrl = process.env.WEBSITE_URL + String(coverImage);
  const schemaOrgConfig = getSchemaOrgJSONLD({ pageMetaData, siteMetadata });
  const canonicalUrl = `${process.env.WEBSITE_URL}${path}`;

  return (
    <>
      <html lang="en" data-theme="theme" />
      <link rel="canonical" href={canonicalUrl} />
      {/* <script src="https://www.googleoptimize.com/optimize.js?id=GTM-T4WV6XZ" /> */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgConfig)}
      </script>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Polo Themes" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@truemarkDev" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:image" content={imageUrl} />
      </>
  );
};

export default SiteMetaData;
